import { IonActionSheet, IonButton, IonIcon } from "@ionic/react";
import { useAppContext } from "State/Global/AppContext";
import { t } from "i18next";
import React, { useState } from "react";
import CTA from "Constants";
import { ellipsisHorizontal, informationCircleOutline, hardwareChipOutline } from "ionicons/icons";
import { isNativeIos } from "frontend-lib/Utils/Mobile";

interface ChatHandlerButtonsNativeProps {
    showAssignButton: boolean;
    handlers: {
        handleChatOptions: (chat: any, owner: any, action: any) => void;
        handleNote: () => void;
        handleDeselectChat: () => void;
        handleReloadHistory: (chat: any) => Promise<void>;
        handleOpenInfo: () => void;
        handleOpenPredictModal: () => void;
    };
}

export default function ChatHandlerButtonsNative({
    showAssignButton,
    handlers,
}: ChatHandlerButtonsNativeProps) {
    //@ts-ignore
    const { appState } = useAppContext();

    const [isActionSheetOpen, setIsActionSheetOpen] = useState(false);

    const unassignButton = {
        text: t("chatOptions.unassign"),
        data: {
            actionCb: () =>
                handlers.handleChatOptions(
                    appState.selectedChat,
                    CTA.CHATS.OPTIONS.UNASSIGNED,
                    CTA.CHATS.OPTIONS.UNASSIGN
                ),
        },
    };

    const assignButton = {
        text: t("chatOptions.assign"),
        data: {
            actionCb: () =>
                handlers.handleChatOptions(
                    appState.selectedChat,
                    CTA.CHATS.OPTIONS.ME,
                    CTA.CHATS.OPTIONS.ASSIGN
                ),
        },
    };

    const buttons = [
        !showAssignButton ? assignButton : unassignButton,
        {
            text: t("notes.create"),
            data: {
                actionCb: () => handlers.handleNote(),
            },
        },
        {
            text: t("reload"),
            data: {
                actionCb: () => handlers.handleReloadHistory(appState.selectedChat),
            },
        },
        {
            text: t("closeChat"),
            role: "destructive",
            data: {
                actionCb: () => handlers.handleDeselectChat(),
            },
        },
    ];

    return (
        <div className="header-actions" key="actions">
            <IonButton onClick={() => setIsActionSheetOpen(true)} fill="outline">
                <IonIcon icon={ellipsisHorizontal} />
            </IonButton>

            <IonButton onClick={handlers.handleOpenPredictModal}>
                <IonIcon icon={hardwareChipOutline} />
            </IonButton>

            <IonButton onClick={() => handlers.handleOpenInfo()}>
                <IonIcon icon={informationCircleOutline} />
            </IonButton>

            <IonActionSheet
                cssClass={isNativeIos() ? "optiwe-action-sheet" : ""}
                isOpen={isActionSheetOpen}
                onDidDismiss={({ detail }) => {
                    detail.data?.actionCb();
                    setIsActionSheetOpen(false);
                }}
                buttons={buttons}
            />
        </div>
    );
}
